module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sekundærlogo_sentrert_pos.01e9c194.png";